<template>
  <div class="app bg-gradient-to-b from-sky-400 to-blue-950 min-h-screen">
    <navigation-panel-component />
    <map-component />
  </div>

</template>

<script>

import MapComponent from '@/components/MapComponent.vue';
import NavigationPanelComponent from '@/components/NavigationPanelComponent.vue';


export default {
  components: {
    MapComponent,
    NavigationPanelComponent

  },
}

</script>

<style>
.app {
  padding: 20px;
}
</style>